var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article || _vm.page)?_c('newsarticle',{attrs:{"article":_vm.article || _vm.page}}):(_vm.issue)?_c('issue-article',{attrs:{"article":_vm.issue}}):(_vm.chapter)?_c('chapter',{attrs:{"data":_vm.chapter}}):_c('div',{staticStyle:{"height":"10000px"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6acc68d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MainPage.vue
// module id = 486
// module chunks = 1